<template>
  <v-row>
    <loading v-if="vLoading" />

    <v-col cols="12">
      <b-card
        v-if="
          $router.currentRoute.path == '/' + role + '/order/' + $route.params.id
        "
      >
        <loading v-if="vLoading" />
        <i
          class="mr-3 fa fa-question-circle text-dark"
          @click="toggleHelp()"
          v-shortkey.once="['ctrl' + 'q']"
          @shortkey="toggleHelp()"
        ></i>

        <span v-if="orderInfo.isUrgent" class="text-danger" style="float: left">
          <blink
            ><i class="mr-3 fa fa-exclamation-triangle text-danger"> </i
          ></blink>
          <blink>استعلام فوریت دارد</blink>
        </span>
        <b-btn
          hidden
          @click="changeTab(1)"
          v-shortkey.once="['ctrl' + 'arrowleft']"
          @shortkey="changeTab(1)"
          >+</b-btn
        >
        <b-btn
          hidden
          @click="changeTab(-1)"
          v-shortkey.once="['ctrl' + 'arrowright']"
          @shortkey="changeTab(-1)"
          >-</b-btn
        >
        <v-dialog v-model="agentDialog" max-width="600px">
          <v-card>
            <v-card-title>
              <h4>اطلاعات رابط</h4>
            </v-card-title>
            <v-card-text class="py-0 px-2">
              <v-container class="mt-3">
                <ul>
                  <li v-if="agent.customerName" class="mx-5">
                    <strong>نام مشتری: </strong>{{ agent.customerName }}
                  </li>
                  <li v-if="agent.name" class="mx-5">
                    <strong>نام رابط: </strong>{{ agent.name }}
                  </li>
                  <li v-if="agent.nameEn" class="mx-5">
                    <strong>نام انگلیسی رابط: </strong>{{ agent.nameEn }}
                  </li>
                  <li v-if="agent.role" class="mx-5">
                    <strong>سمت: </strong>{{ agent.role }}
                  </li>
                  <li v-if="agent.phone" class="mx-5">
                    <strong>تلفن: </strong>{{ agent.phone }}
                  </li>
                  <li v-if="agent.phone2" class="mx-5">
                    <strong>تلفن 2: </strong>{{ agent.phone2 }}
                  </li>
                  <li v-if="agent.internal" class="mx-5">
                    <strong>داخلی: </strong>{{ agent.internal }}
                  </li>
                  <li v-if="agent.fax" class="mx-5">
                    <strong>فکس: </strong>{{ agent.fax }}
                  </li>
                  <li v-if="agent.mobile" class="mx-5">
                    <strong>موبایل: </strong>{{ agent.mobile }}
                  </li>
                  <li v-if="agent.email" class="mx-5">
                    <strong>ایمیل: </strong>{{ agent.email }}
                  </li>
                  <li v-if="agent.postalCode" class="mx-5">
                    <strong>کد پستی: </strong>{{ agent.postalCode }}
                  </li>
                  <li v-if="agent.address" class="mx-5">
                    <strong>آدرس: </strong>{{ agent.address }}
                  </li>
                </ul>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <b-tabs pills card content-class="mt-3" v-model="tabIndex">
          <b-tab title="عمومی" active>
            <b-card header-text-variant="white">
              <template v-slot:header>
                <v-row :class="orderInfo.customer_priority">
                  <v-col cols="7" class="mt-4">
                    <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

                    <h5>
                      نام مشتری:
                      <a
                        v-if="role != 'tradeIntern'"
                        :href="
                          '/' +
                          role +
                          '/customerProfile/' +
                          orderInfo.customerId
                        "
                        target="_blank"
                        >{{ orderInfo.customerName }}</a
                      >
                      <span v-else>
                        {{ orderInfo.customerName }}
                      </span>
                    </h5>
                    <h5>
                      شماره درخواست مشتری: {{ orderInfo.originalRequestId }}
                      <b-btn
                        :disabled="role == 'tradeIntern'"
                        class="mx-2"
                        variant="link primary"
                        @click="editRequestId()"
                      >
                        ویرایش
                      </b-btn>
                    </h5>
                    <h5>
                      کارشناس مشتری:

                      {{ orderInfo.contactName }}

                      <b-btn
                        :disabled="role == 'tradeIntern'"
                        class="mx-3"
                        variant="link primary"
                        @click="editRequestAgent()"
                      >
                        ویرایش
                      </b-btn>

                      <b-btn variant="light text-dark" @click="clickOnAgent()">
                        مشاهده جزییات
                      </b-btn>
                    </h5>
                    <h5 v-if="orderType">
                      نوع استعلام:
                      {{
                        orderTypes.filter((x) => x.value == orderType)[0].text
                      }}
                    </h5>
                    <b-btn
                      v-if="
                        orderInfo.status == 'ثبت استعلام' &&
                        orderInfo.assigneeId == currentUserId
                      "
                      class="mt-1"
                      variant="primary"
                      @click="gotoPricing()"
                      >صدور استعلام</b-btn
                    >
                    <b-btn
                      v-if="
                        orderInfo.status == 'در انتظار نظر مشتری' &&
                        (role == 'secretary' ||
                          role == 'secretaryStatus' ||
                          role == 'Manager')
                      "
                      class="mt-1"
                      variant="light text-dark"
                      @click="openModalGet()"
                      >دریافت پاسخ مشتری</b-btn
                    >
                  </v-col>

                  <v-col cols="5" class="mt-4">
                    <v-col>
                      <v-row>
                        <v-col>
                          <h4>
                            وضعیت پرونده:
                            <a
                              v-if="role != 'tradeIntern'"
                              target="_blank"
                              :href="orderInfo.statusLink"
                            >
                              {{ orderInfo.status }}
                            </a>
                            <span v-else>
                              {{ orderInfo.status }}
                            </span>
                          </h4>
                          <h5>
                            تاریخ ثبت استعلام: {{ orderInfo.registerDate }}
                          </h5>
                          <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                          <h5>
                            کارشناس بازرگانی:
                            {{ orderInfo.assigneeName }}
                          </h5>
                          <b-btn
                            class="mr-1 mt-1"
                            variant="success"
                            @click="assignToMe()"
                            v-if="
                              orderInfo.assigneeName == '-' &&
                              (role == 'Manager' ||
                                role == 'salesManager' ||
                                role == 'tradeHead' ||
                                role == 'trade') &&
                              orderInfo.status != 'عدم' &&
                              orderInfo.status != 'آرشیو'
                            "
                            >تخصیص به من</b-btn
                          >&nbsp;
                          <b-btn
                            class="mr-1 mt-1"
                            variant="danger"
                            @click="openRemoveAssigneeDialog()"
                            v-if="
                              orderInfo.assigneeName != '-' &&
                              (role == 'Manager' ||
                                role == 'salesManager' ||
                                role == 'tradeHead') &&
                              orderInfo.status != 'عدم' &&
                              orderInfo.status != 'آرشیو'
                            "
                            >حذف مجری</b-btn
                          >&nbsp;
                          <!-- <h5>درصد پیشرفت کار: {{ doneProgress }} %</h5> -->

                          <!-- <p>تاریخ ثبت استعلام: {{shamsiStartDate}}</p>
                          <p>تاریخ ثبت استعلام: {{shamsiStartDate}}</p>-->
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- <b-progress
                      :max="max"
                      height="2rem"
                      class="mt-1"
                    >
                      <b-progress-bar
                        show-progress
                        animated
                        :value="timeProgress"
                        :variant="timeProgress>doneProgress ? 'danger' : 'success'"
                      >{{timeProgress}} %</b-progress-bar>
                    </b-progress>-->
                  </v-col>
                </v-row>
              </template>
              <v-row>
                <v-col cols="12">
                  <b-card>
                    <template v-slot:header>
                      متن بالای استعلام
                      <b-btn
                        :disabled="role == 'tradeIntern'"
                        @click="editCustomerTerms()"
                        variant="primary"
                        class="float-left"
                        >ویرایش</b-btn
                      >
                    </template>
                    <div><span v-html="orderInfo.customerTerms"></span></div>
                  </b-card>
                  <b-card>
                    <template v-slot:header>
                      متن پایین استعلام
                      <b-btn
                        :disabled="role == 'tradeIntern'"
                        @click="editTerms()"
                        variant="primary"
                        class="float-left"
                        >ویرایش</b-btn
                      >
                    </template>
                    <div>
                      <span v-html="orderInfo.terms"></span>
                    </div>
                  </b-card>

                  <b-card>
                    <template v-slot:header>
                      <div>
                        <span> نحوه ارسال سفارش </span>
                        <b-btn
                          :disabled="role == 'tradeIntern'"
                          @click="editOrder()"
                          variant="primary"
                          class="float-left"
                          >ویرایش</b-btn
                        >
                      </div>
                    </template>
                    <div>
                      <span v-if="orderInfo.orderSendMethod">{{
                        orderSendMethods.filter(
                          (x) => x.value == orderInfo.orderSendMethod
                        )[0].text
                      }}</span>
                      <span v-else>مشخص نشده است</span>
                    </div>
                  </b-card>

                  <b-card>
                    <template v-slot:header>
                      <div>
                        <span>نحوه دریافت درخواست </span>
                        <b-btn
                          :disabled="role == 'tradeIntern'"
                          @click="editRequest()"
                          variant="primary"
                          class="float-left"
                          >ویرایش</b-btn
                        >
                      </div>
                    </template>
                    <div>
                      <span v-if="orderInfo.orderReceivedMethod">{{
                        orderReceivedMethods.filter(
                          (x) => x.value == orderInfo.orderReceivedMethod
                        )[0].text
                      }}</span>
                      <span v-else>مشخص نشده است</span>
                    </div>
                  </b-card>
                  <b-card v-if="orderInfo.description">
                    <template v-slot:header> توضیحات </template>
                    <div>
                      <span v-html="orderInfo.description"></span>
                    </div>
                  </b-card>
                  <b-card
                    v-if="
                      orderInfo.history &&
                      orderInfo.history.filter(
                        (x) => x.message.indexOf('مشتری') > -1
                      ).length
                    "
                  >
                    <template v-slot:header> مکاتبات با مشتری </template>
                    <div>
                      <ul>
                        <li
                          v-for="item in orderInfo.history.filter(
                            (x) => x.message.indexOf('مشتری') > -1
                          )"
                          :key="item.id"
                          class="mr-3"
                        >
                          {{ item.message }} ({{
                            item.date.replace(" ", " - ")
                          }})
                        </li>
                      </ul>
                    </div>
                  </b-card>
                  <b-card>
                    <template v-slot:header>فوریت استعلام</template>
                    <div @click="showConfirmToggleUrgentModal()">
                      <h6>
                        میتوانید از این بخش، وضعیت فوریت استعلام را تغییر دهید.
                      </h6>
                      <v-progress-circular
                        v-if="isUrgentLoading"
                        :size="15"
                        :width="1"
                        indeterminate
                      ></v-progress-circular>
                      <v-switch
                        v-else
                        disabled
                        v-model="orderInfo.isUrgent"
                        hide-details
                        inset
                        color="error"
                        :label="
                          'استعلام فوریت ' +
                          (orderInfo.isUrgent ? 'دارد' : 'ندارد')
                        "
                      ></v-switch>

                      <div class="mt-4">
                        <h6>تاریخچه فوریت:</h6>
                        <ul
                          v-if="
                            orderInfo.history &&
                            orderInfo.history.filter(
                              (x) => x.message.indexOf('فوری') > -1
                            ).length
                          "
                        >
                          <li
                            v-for="item in orderInfo.history.filter(
                              (x) => x.message.indexOf('فوری') > -1
                            )"
                            :key="item.id"
                            class="mr-3"
                          >
                            {{ item.name }}: {{ item.message }} ({{
                              item.date.replace(" ", " - ")
                            }}
                            )
                          </li>
                        </ul>
                      </div>
                    </div>
                  </b-card>
                </v-col>

                <v-col cols="12">
                  <b-card>
                    <template v-slot:header>
                      <h5 class="my-0">عملیات</h5>
                    </template>
                    <!-- <b-btn
                      class="btn-lg h-100 w-100 mt-4 color1"
                      @click="toCustomerModal()"
                      disabled
                      >پیام به مشتری</b-btn
                    >
                    <b-btn
                      class="btn-lg h-100 w-100 mt-4 color2"
                      variant="primary"
                      @click="ceoReferModal()"
                      disabled
                      >ارجاع به مدیریت</b-btn
                    > -->
                    <b-btn
                      class="btn-lg h-100 w-100 mt-4"
                      variant="success"
                      @click="newNoteModal()"
                      v-shortkey.once="['ctrl' + 'm']"
                      @shortkey="newNoteModal()"
                      >یادداشت</b-btn
                    >
                    <b-btn
                      class="btn-lg h-100 w-100 mt-4"
                      variant="dark"
                      @click="progressModal()"
                      :disabled="
                        !(
                          role == 'Manager' ||
                          role == 'salesManager' ||
                          role == 'secretary' ||
                          role == 'secretaryStatus'
                        )
                      "
                      >تغییر وضعیت</b-btn
                    >
                    <b-btn
                      class="btn-lg h-100 w-100 mt-4"
                      variant="warning"
                      @click="revisionModal()"
                      :disabled="!(role == 'Manager') || !orderInfo.mainOrder"
                      >{{
                        orderInfo.mainOrder
                          ? "ریویژن"
                          : "برای ثبت ریویژن به آخرین نسخه مراجعه کنید"
                      }}</b-btn
                    >
                  </b-card>
                </v-col>
              </v-row>
            </b-card>
          </b-tab>
          <b-tab title="فایل‌ها">
            <b-card
              header-bg-variant="secondary"
              header-text-variant="white"
              header="جدول فایل‌های آپلود شده"
              class="shadow p-3 mb-5 bg-white rounded"
            >
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
              <b-table
                v-if="myFiles.length"
                responsive
                show-empty
                :items="myFiles"
                :fields="fields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :busy="isBusy"
                :filter="filter"
              >
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>

                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- <b-button variant="success" @click="downloadFile(data.download)"><i
                        class="fa fa-download"
                        aria-hidden="true"
                    ></i></b-button>-->
                    <a
                      class="btn btn-success"
                      :href="data.item.url"
                      target="_blank"
                      role="button"
                    >
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </a>
                    &nbsp;
                    <b-btn
                      v-if="
                        role == 'Manager' ||
                        role == 'secretary' ||
                        role == 'secretaryStatus'
                      "
                      variant="danger"
                      @click="delFile(data.item)"
                    >
                      <i class="fa fa-remove" aria-hidden="true"></i>
                    </b-btn>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-form-group label="بارگذاری فایل:" label-for="indexPic">
                <b-form-file
                  :state="Boolean(file)"
                  @input="upload(file)"
                  v-model="file"
                  browse-text="آپلود"
                  placeholder="فایل مربوطه را آپلود کنید"
                  accept="*"
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <v-col>
                  <br />
                  <b-progress
                    v-if="myFile.showProgress"
                    :value="myFile.uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="myFile.striped"
                    :variant="myFile.variant"
                  ></b-progress>
                  <v-row>
                    <br />
                    <div v-if="myFile.isUploaded" color="green" class="p-3">
                      فایل با موفقیت آپلود شد.
                    </div>
                  </v-row>
                </v-col>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab title="یادداشت‌ها">
            <b-card header-bg-variant="secondary" header-text-variant="white">
              <template v-slot:header>
                <h5>
                  کاربر گرامی، کلیه تغییراتی که روی کار انجام شده است در این بخش
                  قابل مشاهده می‌باشد
                </h5>
              </template>

              <v-row class="mb-4"></v-row>
              <v-row
                v-for="item in orderInfo.history"
                :key="item.id"
                class="mt-3"
              >
                <v-col cols="1"></v-col>
                <v-col cols="1"></v-col>
                <v-col cols="10">
                  <b-card
                    text-variant="dark"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    style="max-width: 80%"
                    class="shadow-lg p-0 mb-0 bg-white rounded h-100"
                  >
                    <template v-slot:header>
                      <v-row>
                        <v-col cols="6">
                          <h5>{{ item.name }}</h5>
                        </v-col>
                        <v-col cols="6">
                          <h5 style="float: left">
                            <span dir="ltr">{{
                              item.date.replace(" ", " - ")
                            }}</span>
                          </h5>
                        </v-col>
                      </v-row>
                    </template>
                    <b-card-text>
                      <div v-html="item.message"></div>
                      <br />
                    </b-card-text>
                  </b-card>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="1"></v-col>
              </v-row>
            </b-card>
          </b-tab>
          <!-- <b-tab title="رابط‌های مشتری">
            <b-card header-bg-variant="secondary" header-text-variant="white">
              <template v-slot:header>
                <h5>لیست کلیه کارشناسان مشتری در این بخش نمایش داده میشود</h5>
              </template>

              <v-row class="mb-4"></v-row>
            </b-card>
          </b-tab> -->

          <b-tab title="نامه‌ها" v-if="letters.length">
            <b-card
              header-bg-variant="secondary"
              header-text-variant="white"
              header="جدول نامه‌ها"
              class="shadow p-3 mb-5 bg-white rounded"
            >
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="letterFilter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!letterFilter"
                      @click="letterFilter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
              <b-table
                responsive
                show-empty
                :items="letters"
                :fields="letterFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :filter="letterFilter"
              >
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(type)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      class="mx-auto ps-6 pe-6"
                      :class="
                        data.value == 'inbox'
                          ? 'purple-badge'
                          : data.value == 'internal'
                          ? 'blue-badge'
                          : 'orange-badge'
                      "
                    >
                      {{
                        data.value == "outbox"
                          ? "خروجی"
                          : data.value == "inbox"
                          ? "ورودی"
                          : "سازمانی"
                      }}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <b-btn
                      variant="primary"
                      :to="
                        '/' +
                        role +
                        '/secretariat/' +
                        data.item.type +
                        '/letterInfo/' +
                        data.item._id
                      "
                      target="_blank"
                    >
                      مشاهده جزئیات نامه
                    </b-btn>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab
            v-if="orderInfo.orderItems && orderInfo.orderItems.length > 0"
            title="آخرین اقلام استعلام"
          >
            <vue-excel-xlsx
              v-if="orderInfo.orderItems && orderInfo.orderItems.length > 0"
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                orderInfo.orderItems.map((x) => {
                  return {
                    totalPrice: '',
                    perPrice: sarmadNumber(x.perPrice),
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                  };
                })
              "
              :columns="
                myOriginalFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
                  .filter((x) => x.field != 'totalPrice')
              "
              :file-name="
                orderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="orderInfo.orderCode"
              >خروجی اکسل</vue-excel-xlsx
            >
            <a
              class="btn mx-3 rounded p-2 btn-secondary"
              style="float: left"
              :href="'/' + role + '/printPreview/full/' + $route.params.id"
              target="_blank"
            >
              نسخه چاپی
            </a>
            <b-table
              responsive
              show-empty
              :items="orderInfo.orderItems"
              :fields="myOriginalFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
              style="font-family: Tahoma !important"
            >
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(totalPrice)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ (data.item.perPrice * data.item.number).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(number)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ (1 * data.item.number).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(perPrice)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ (data.item.perPrice * 1).toLocaleString() }}
                </div>
              </template>
            </b-table>
            <div>
              <v-row>
                <v-col cols="3">واحد اندازه‌گیری:</v-col>
                <v-col cols="3"
                  >{{
                    orderInfo.measurementUnit
                      ? orderInfo.measurementUnit
                      : "مشخص نشده است"
                  }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">قیمت کل اقلام:</v-col>
                <v-col cols="3"
                  >{{
                    orderInfo.orderItems && orderInfo.orderItems.length > 0
                      ? parseFloat(
                          sarmadNumber(
                            orderInfo.orderItems
                              .map(
                                (x) =>
                                  (x.perPrice
                                    ? x.perPrice.toString().replace(/\s/g, "")
                                    : 0) *
                                  (x.number
                                    ? x.number.toString().replace(/\s/g, "")
                                    : 0)
                              )
                              .reduce((a, b) => a + b)
                          )
                        ).toLocaleString()
                      : "--"
                  }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(packagingCost) > 0" class="mt-2">
                <v-col cols="3">هزینه بسته‌بندی:</v-col>
                <v-col cols="3"
                  >‌{{
                    parseFloat(sarmadNumber(packagingCost)).toLocaleString()
                  }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(transportCost) > 0" class="mt-2">
                <v-col cols="3">هزینه حمل:</v-col>
                <v-col cols="3"
                  >‌{{
                    parseFloat(sarmadNumber(transportCost)).toLocaleString()
                  }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(personCost) > 0" class="mt-2">
                <v-col cols="3">هزینه بازرسی شخص ثالث:</v-col>
                <v-col cols="3"
                  >{{ parseFloat(sarmadNumber(personCost)).toLocaleString() }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(coatingCost) > 0" class="mt-2">
                <v-col cols="3">هزینه پوشش دهی:</v-col>
                <v-col cols="3"
                  >{{
                    orderInfo.orderItems && orderInfo.orderItems.length > 0
                      ? (
                          parseFloat(
                            sarmadNumber(
                              orderInfo.orderItems
                                .map(
                                  (x) =>
                                    (x.perPrice
                                      ? x.perPrice.toString().replace(/\s/g, "")
                                      : 0) *
                                    (x.number
                                      ? x.number.toString().replace(/\s/g, "")
                                      : 0)
                                )
                                .reduce((a, b) => a + b)
                            )
                          ) *
                          (coatingCost / 100)
                        ).toLocaleString()
                      : "--"
                  }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(certificationCost) > 0" class="mt-2">
                <v-col cols="3">هزینه تست و صدور گواهینامه:‌</v-col>
                <v-col cols="3"
                  >{{
                    parseFloat(sarmadNumber(certificationCost)).toLocaleString()
                  }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(otherCost) > 0" class="mt-2">
                <v-col cols="3">سایر هزینه‌ها:‌</v-col>
                <v-col cols="3"
                  >{{ parseFloat(sarmadNumber(otherCost)).toLocaleString() }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row v-if="parseInt(discount) > 0" class="mt-2">
                <v-col cols="3">تخفیف {{ orderInfo.currency }}ی:‌</v-col>
                <v-col cols="3"
                  >{{ parseFloat(sarmadNumber(discount)).toLocaleString() }}
                  {{ orderInfo.currency }}</v-col
                >
              </v-row>
              <v-row
                v-if="
                  discount +
                  packagingCost +
                  transportCost +
                  personCost +
                  certificationCost +
                  otherCost
                "
              >
                <v-col cols="3">
                  <strong> قیمت کل بدون مالیات:‌ </strong>
                </v-col>
                <v-col cols="3">
                  <strong>
                    {{
                      totalPriceVatExcluded(
                        orderInfo.orderItems,
                        discount,
                        packagingCost,
                        transportCost,
                        personCost,
                        certificationCost,
                        otherCost,
                        orderInfo.currency
                      )
                    }}
                  </strong>
                </v-col>
              </v-row>
              <v-row v-if="parseInt(vat) > 0" class="mt-2">
                <v-col cols="3">مالیات بر ارزش افزوده ({{ vat }}%):</v-col>
                <v-col cols="3"
                  >{{
                    totalVat(
                      orderInfo.orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      orderInfo.currency,
                      vat
                    )
                  }}
                </v-col>
              </v-row>
              <hr />
              <v-row>
                <v-col cols="3">
                  <strong>قیمت کل:‌</strong>
                </v-col>
                <v-col cols="3">
                  <strong>
                    {{
                      totalPrice(
                        orderInfo.orderItems,
                        discount,
                        packagingCost,
                        transportCost,
                        personCost,
                        certificationCost,
                        otherCost,
                        orderInfo.currency,
                        vat
                      )
                    }}
                  </strong>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  totalPriceNumeric(
                    orderInfo.orderItems,
                    discount,
                    packagingCost,
                    transportCost,
                    personCost,
                    certificationCost,
                    otherCost,
                    orderInfo.currency,
                    vat
                  ) != orderInfo.price
                "
              >
                <v-col cols="3">
                  <em>قیمت اعلامی به مشتری:‌</em>
                </v-col>
                <v-col cols="3">
                  <em>
                    {{ orderInfo.price.toLocaleString() }}
                    {{ orderInfo.currency }}
                  </em>
                </v-col>
                <v-col cols="6">
                  <em>
                    قیمت ارسالی به مشتری با فرمول قدیمی و با مغایرت با قیمت فعلی
                    ثبت شده است.
                  </em>
                </v-col>
              </v-row>
            </div>
          </b-tab>
          <b-tab
            v-if="
              orderInfo.tempOrderItems && orderInfo.tempOrderItems.length > 0
            "
            title="اقلام تولید"
          >
            <vue-excel-xlsx
              v-if="
                orderInfo.tempOrderItems && orderInfo.tempOrderItems.length > 0
              "
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                orderInfo.tempOrderItems.map((x) => {
                  return {
                    totalPrice: '',
                    perPrice: '',
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                  };
                })
              "
              :columns="
                myFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
                  .filter((x) => x.field != 'totalPrice')
                  .filter((x) => x.field != 'perPrice')
              "
              :file-name="
                orderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="orderInfo.orderCode"
              >خروجی اکسل</vue-excel-xlsx
            >
            <b-table
              responsive
              show-empty
              :items="orderInfo.tempOrderItems"
              :fields="
                myFields
                  .filter((x) => x.key != 'totalPrice')
                  .filter((x) => x.key != 'perPrice')
              "
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
              style="font-family: Tahoma !important"
            >
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(number)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ (1 * data.item.number).toLocaleString() }}
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab v-if="orderInfo.revision > 0" title="سایر ریویژن‌ها">
            <b-table
              responsive
              show-empty
              :items="orderInfo.revisions"
              :fields="myRevisionFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
              style="font-family: Tahoma !important"
            >
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  <a
                    :href="'/' + role + '/order/' + data.value"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    مشاهده جزییات</a
                  >
                </div>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </v-col>

    <v-dialog v-model="toCustomerDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>پیام به</h4>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container>
            <v-text-field
              type="text"
              label="عنوان"
              v-model="subject"
              class="pt-3"
              dense
              outlined
            ></v-text-field>
            <p>متن پیام:</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="contentCustomerModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <br />
            <v-select
              label="نحوه ارسال پیام"
              :items="options"
              v-model="selected"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeCustomerMssg()">
            لغو
          </v-btn>
          <v-btn color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ceoReferDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ارجاع به مدیریت</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="contentAssigneeModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeCeoRefer()">
            لغو
          </v-btn>
          <v-btn color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newNoteDialog" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>یادداشت</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="contentNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="newNoteDialog = false">
            لغو
          </v-btn>
          <v-btn @click="sendNote()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sureDelFile" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>آیا از حذف فایل مطمئن هستید؟</h4>
        </v-card-title>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="sureDelFile = false">
            خير
          </v-btn>
          <v-btn @click="doDelFile()" color="primary"> بله </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="progressDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>تغییر وضعیت</h4>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-container v-if="role == 'secretary'">
            <p>
              منشی گرامی، شما تنها در صورتی قادر به ویرایش نوع استعلام هستید که
              وضعیت آن «ثبت استعلام» باشد.
            </p>
            <v-select
              label="نوع استعلام مورد نظر"
              :items="orderTypes"
              v-model="orderType"
              outlined
              dense
              @change="newStatusId = 'ثبت استعلام'"
              :disabled="orderInfo.status != 'ثبت استعلام'"
            />
            <v-text-field
              label="وضعیت فعلی"
              v-model="orderInfo.status"
              outlined
              dense
              disabled
            >
            </v-text-field>
            <v-select
              label="وضعیت جدید"
              :items="statusOptions[orderType]"
              v-model="newStatusId"
              outlined
              dense
              disabled
            />
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="statusNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
                :disabled="orderInfo.status != 'ثبت استعلام'"
              />
            </div>
          </v-container>
          <v-container v-else>
            <v-select
              label="نوع استعلام مورد نظر"
              :items="orderTypes"
              v-model="orderType"
              outlined
              dense
              @change="newStatusId = ''"
            />
            <v-text-field
              label="وضعیت فعلی"
              v-model="orderInfo.status"
              outlined
              dense
              disabled
            >
            </v-text-field>
            <v-select
              label="وضعیت جدید"
              :items="statusOptions[orderType]"
              v-model="newStatusId"
              outlined
              dense
            />
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="statusNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="progressDialog = false">
            لغو
          </v-btn>
          <v-btn
            :disabled="!newStatusId"
            @click="submitModalProgress()"
            color="primary"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="revisionDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ثبت ریویژن</h4>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-container>
            <p>
              با این عملیات شما استعلام را به ریویژن تغییر می دهید. وضعیت
              استعلام به «ثبت استعلام» تغییر خواهد کرد و محتوای ریویژن بعدی از
              نسخه انتخاب شده کپی میشود
            </p>
            <ul>
              <li>نسخه فعلی: {{ orderInfo.revision }}</li>
              <li>نسخه ریویژن بعدی: {{ orderInfo.revision + 1 }}</li>
            </ul>
            <v-select
              v-if="orderInfo.revision > 0"
              label="کپی ریویژن از نسخه"
              class="mt-3"
              :items="revisionOptions"
              v-model="sourceRevisionId"
              outlined
              dense
            />
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="revisionNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="revisionDialog = false">
            لغو
          </v-btn>
          <v-btn
            :disabled="isNaN(sourceRevisionId)"
            @click="submitRevisionModal()"
            color="primary"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeAssigneeDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>حذف مجری</h4>
        </v-card-title>
        <v-card-text class="py-2 text-center">
          <v-container>
            <h5>آیا از حذف مجری اطمینان دارید؟</h5>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="removeAssigneeDialog = false"
          >
            خیر
          </v-btn>
          <v-btn class="mx-auto" color="primary" @click="removeAssignee()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editCustomerTermsDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>ویرایش متن بالای استعلام</h4>
        </v-card-title>
        <v-card-text class="py-2 item-ckeditor">
          <v-container>
            <h3>متن قبلی</h3>
            <p v-html="orderInfo.customerTerms"></p>
            <h3>متن جدید</h3>
            <ckeditor
              v-model="tempCustomerTerms"
              :editor="editor"
              :config="editorConfig"
            ></ckeditor>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="editCustomerTermsDialog = false"
          >
            لغو تغییرات
          </v-btn>
          <v-btn
            class="mx-auto"
            color="primary"
            @click="submitEditCustomerTerms()"
          >
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editTermsDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>ویرایش متن پایین استعلام</h4>
        </v-card-title>
        <v-card-text class="py-2 item-ckeditor">
          <v-container>
            <h3>متن قبلی</h3>
            <p v-html="orderInfo.terms"></p>
            <h3>متن جدید</h3>
            <ckeditor
              v-model="tempTerms"
              :editor="editor"
              :config="editorConfig"
            ></ckeditor>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="editTermsDialog = false"
          >
            لغو تغییرات
          </v-btn>
          <v-btn class="mx-auto" color="primary" @click="submitEditTerms()">
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDeliveryDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>
            {{
              this.selectedDelivery == "request"
                ? "نحوه دریافت درخواست"
                : "نحوه ارسال سفارش"
            }}
          </h4>
        </v-card-title>
        <v-card-text class="py-2">
          <v-container v-if="this.selectedDelivery == 'order'">
            <v-select
              label="روش ارسال سفارش"
              :items="sendMethods"
              v-model="tempSendTerms"
              outlined
              dense
            />
          </v-container>
          <v-container v-else>
            <v-select
              label="نحوه دریافت درخواست"
              :items="receivedMethods"
              v-model="tempReceiveTerms"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="editDeliveryDialog = false"
          >
            لغو تغییرات
          </v-btn>
          <v-btn
            class="mx-auto"
            color="primary"
            @click="submitEditOrderSendReceiveMethod()"
          >
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editRequestAgentDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>ویرایش کارشناس مشتری</h4>
        </v-card-title>
        <v-card-text class="py-2">
          <v-container>
            <h3>کارشناس قبلی</h3>
            <p>{{ orderInfo.contactName }}</p>
            <h3>کارشناس جدید</h3>
            <v-select
              label="کارشناس مشتری جدید"
              :items="agents"
              v-model="tempRequestAgent"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="editRequestAgentDialog = false"
          >
            لغو تغییرات
          </v-btn>
          <v-btn
            class="mx-auto"
            color="primary"
            @click="submitEditRequestAgent()"
          >
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editRequestIdDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>ویرایش شماره درخواست مشتری</h4>
        </v-card-title>
        <v-card-text class="py-2">
          <v-container>
            <h3>شماره قبلی</h3>
            <p>{{ orderInfo.originalRequestId }}</p>
            <h3>شماره جدید</h3>
            <v-text-field
              type="text"
              label="شماره نامه / نام پروژه درخواست استعلام"
              v-model="tempRequestId"
              dense
              outlined
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="editRequestIdDialog = false"
          >
            لغو تغییرات
          </v-btn>
          <v-btn class="mx-auto" color="primary" @click="submitEditRequestId()">
            ثبت تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="getCustomerDialog" max-width="700px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>دریافت پاسخ مشتری {{ orderInfo.orderCode }}</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>
              همکار گرامی لطفا توضیحات پاسخ مشتری و همچنین فایل مربوطه را (در
              صورت وجود) وارد کنید:
            </p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="getContent"
                :editor="editor"
                :config="editorConfig"
              />
            </div>
            <hr />
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(file)"
                @input="upload2(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
              <br />
            </v-row>
            <v-select
              v-model="response"
              :items="
                orderType == 'technical' ? responsesTechnical : responsesFull
              "
              label="پاسخ مشتری"
              outlined
              dense
              item-text="text"
              item-value="value"
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalGet()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitCustomerResponse()">
            دریافت پاسخ مشتری</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          تب بعدی <br />
          <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-right text-dark"></i
          ></v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          تب قبلی<br />
          <v-btn elevation="6" outlined small>m</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          افزودن یادداشت
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> +
          <v-btn elevation="6" outlined small>Ctrl</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showToggleUrgentModal" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>آیا از تغییر وضعیت اورژانس استعلام اطمینان دارید؟</h4>
        </v-card-title>
        <v-card-text class="text-center">
          استعلام در حال حاضر در وضعیت
          <div :class="orderInfo.isUrgent ? 'text-danger' : 'text-success'">
            {{ orderInfo.isUrgent ? "فوری" : "غیرفوری" }}
          </div>
          قرار دارد. شما با تایید، استعلام را به وضعیت
          <div :class="!orderInfo.isUrgent ? 'text-danger' : 'text-success'">
            {{ !orderInfo.isUrgent ? "فوری" : "غیرفوری" }}
          </div>
          منتقل خواهید کرد. تغییرات شما در تاریخچه استعلام نیز ذخیره خواهد شد.
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="cancelConfirmToggleUrgentModal()"
          >
            خير
          </v-btn>
          <v-btn @click="toggleUrgent()" color="primary"> بله، مطمئنم </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </v-row>
</template>
<script>
import Axios from "axios";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { link } from "fs";
import router from "../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment-jalaali";
import { setTimeout } from "timers";
import Loading from "./Loading.vue";
import prices from "../mixins/prices";

function sarmadNumber(x) {
  return parseFloat(x).toFixed(
    this.orderInfo.currency
      ? this.currencyOptions.filter(
          (x) => x.value == this.orderInfo.currency
        )[0].precision
      : ""
  );
}

export default {
  mixins: [prices],
  data() {
    return {
      guide: false,
      tabIndex: 0,
      allStatuses: [
        { id: 1, name: "ثبت استعلام" },
        { id: 2, name: "در انتظار بررسی فنی" },
        { id: 3, name: "تعیین قیمت توسط مدیر عامل" },
        { id: 4, name: "بررسی تعیین قیمت توسط مدیر فروش" },
        { id: 5, name: "آماده برای امضا" },
        { id: 6, name: "اعلام تعیین قیمت به مشتری" },
        { id: 7, name: "در انتظار نظر مشتری" },
        { id: 8, name: "تایید تعیین قیمت توسط مشتری" },
        { id: 9, name: "رد تعیین قیمت توسط مشتری" },
        { id: 10, name: "عدم" },
        { id: 11, name: "آرشیو" },
        { id: 12, name: "بازبینی تعیین قیمت" },
        { id: 13, name: "آماده ارسال به کارخانه" },
        { id: 14, name: "ارسال به کارخانه" },
      ],
      removeAssigneeDialog: false,
      editCustomerTermsDialog: false,
      tempCustomerTerms: "",
      editTermsDialog: false,
      tempTerms: "",
      editRequestIdDialog: false,
      editRequestAgentDialog: false,
      agents: [],
      agent: {},
      agentDialog: false,
      tempRequestId: "",
      tempRequestAgent: {},
      sarmadNumber: sarmadNumber,
      orderInfo: {},
      subject: "",
      contentCustomerModal: "",
      customerName: "",
      moment: moment,
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      selectedFile: {},
      sureDelFile: false,
      author: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: "fa",
        contentsLangDirection: "rtl",
      },
      currentPage: 1,
      perPage: 10,
      filter: null,
      taskTypeModal: "",
      ticketName: "",
      ticketCode: "",
      progress: "",
      doneProgress: 0,
      max: 100,
      timeProgress: 0,
      startDate: "",
      dueDate: "",
      taskDescription: "",
      time: "",
      notes: "",
      status: "",
      statusOptions: {
        full: [
          { value: "ثبت استعلام", text: "ثبت استعلام" },
          { value: "در انتظار بررسی فنی", text: "در انتظار بررسی فنی" },
          {
            value: "تعیین قیمت توسط مدیر عامل",
            text: "تعیین قیمت توسط مدیر عامل",
          },
          {
            value: "بررسی تعیین قیمت توسط مدیر فروش",
            text: "بررسی تعیین قیمت توسط مدیر فروش",
          },
          { value: "آماده برای امضا", text: "آماده برای امضا توسط مدیر عامل" },
          {
            value: "اعلام تعیین قیمت به مشتری",
            text: "اعلام تعیین قیمت به مشتری",
          },
          { value: "در انتظار نظر مشتری", text: "در انتظار نظر مشتری" },
          {
            value: "تایید تعیین قیمت توسط مشتری",
            text: "تایید تعیین قیمت توسط مشتری",
          },
          {
            value: "رد تعیین قیمت توسط مشتری",
            text: "رد تعیین قیمت توسط مشتری",
          },
          { value: "بازبینی تعیین قیمت", text: "بازبینی تعیین قیمت (آرشیو)" },
          { value: "عدم", text: "عدم" },
          { value: "آرشیو", text: "آرشیو (خروج از دسترس)" },
        ],
        technical: [
          { value: "ثبت استعلام", text: "ثبت استعلام" },
          { value: "در انتظار بررسی فنی", text: "در انتظار بررسی فنی" },
          {
            value: "بررسی تعیین قیمت توسط مدیر فروش",
            text: "بررسی توسط مدیر فروش",
          },
          { value: "آماده برای امضا", text: "آماده برای امضا توسط مدیر عامل" },
          {
            value: "اعلام تعیین قیمت به مشتری",
            text: "اعلام استعلام به مشتری",
          },
          { value: "در انتظار نظر مشتری", text: "در انتظار نظر مشتری" },
          {
            value: "رد تعیین قیمت توسط مشتری",
            text: "رد استعلام توسط مشتری",
          },
          { value: "عدم", text: "عدم" },
          { value: "آرشیو", text: "آرشیو (خروج از دسترس)" },
        ],
      },
      statusNoteModal: "",
      revisionNoteModal: "",
      newStatusId: "",
      statusId: "",
      sourceRevisionId: "",
      revisionOptions: [],
      priority: "",
      slide: 35,
      fields: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ" },
        { key: "showName", label: "نام فایل" },
        { key: "uploaderName", label: "نام فرد آپلودکننده" },
        { key: "operation", label: "دریافت" },
      ],
      fields1: [
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Size Standard" },
        { key: "cover", label: "Coating" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fields1CI: [
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Size Standard" },
        { key: "cover", label: "Coating" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      hasCustomerIndex: false,
      hasSizeStandard: true,
      ticketName: "",
      taskStatus: "",
      Today: "",
      startDate: "",
      dueDate: "",
      items: [],
      history: [],
      assignee: "",
      assigneeId: 0,
      isBusy: false,
      shamsiStartDate: "",
      shamsiDueDate: "",
      contentNoteModal: "",
      contentAssigneeModal: "",
      options: [
        { value: "sms", text: "اس‌ام‌اس" },
        { value: "system", text: "سیستمی" },
        { value: "letter", text: "نامه رسمی" },
      ],
      orderSendMethods: [
        { value: "packet", text: "پاکت دربسته" },
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      orderReceivedMethods: [
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      receivedMethod: "",
      receivedMethods: [
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      orderType: "",
      selected: "",
      role: "",
      currentUserId: "",
      userId: 0,
      totalOrder: {},
      vat: 9,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      otherCost: 0,
      certificationCost: 0,
      discount: 0,
      letterId: "",
      customerPerson: "",
      sendMethod: "مشخص نشده است",
      sendMethods: [
        { value: "packet", text: "پاکت دربسته" },
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      newNoteDialog: false,
      toCustomerDialog: false,
      ceoReferDialog: false,
      progressDialog: false,
      revisionDialog: false,
      myFields: [],
      myOriginalFields: [],
      myRevisionFields: [
        { key: "revision", label: "نسخه" },
        { key: "orderType", label: "نوع استعلام" },
        { key: "status", label: "وضعیت" },
        { key: "id", label: "عملیات" },
      ],
      extraDetails: false,
      myFiles: ["a"],
      getCustomerDialog: false,
      getContent: "",
      response: "none",
      responsesFull: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      responsesTechnical: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با استعلام فنی موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با استعلام فنی مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "استعلام فنی نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      letters: [],
      letterFields: [
        { key: "index", label: "#" },
        { key: "letterNo", label: "شماره نامه" },
        { key: "title", label: "عنوان" },
        { key: "date", label: "تاریخ" },
        { key: "type", label: "نوع نامه" },
        { key: "operation", label: "عملیات" },
      ],
      letterFilter: null,
      isUrgentLoading: false,
      showToggleUrgentModal: false,
      selectedDelivery: "",
      editDeliveryDialog: false,
      tempReceiveTerms: "",
      tempSendTerms: "",
    };
  },
  components: {
    VueSlider,
    datePicker: VuePersianDatetimePicker,
    CKEditor,
    Loading,
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    changeTab(itteration) {
      this.tabIndex += itteration;
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    assignToMe() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/assignToMe",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.getTaskInfo(), this.toast(res.data, "success");
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showConfirmToggleUrgentModal() {
      this.isUrgentLoading = true;
      this.showToggleUrgentModal = true;
    },
    cancelConfirmToggleUrgentModal() {
      this.isUrgentLoading = false;
      this.showToggleUrgentModal = false;
    },
    toggleUrgent() {
      Axios.post(
        this.baseUrl + "/ppkpms/office/order/toggleUrgent",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isUrgentLoading = false;
          this.showToggleUrgentModal = false;
          this.toast(res.data, "success");
          this.getTaskInfo();
        })
        .catch((err) => {
          this.isUrgentLoading = false;
          this.showToggleUrgentModal = false;
          this.toast(err.response.data, "error");
        });
    },
    openRemoveAssigneeDialog() {
      this.removeAssigneeDialog = true;
    },
    editCustomerTerms() {
      this.tempCustomerTerms = this.orderInfo.customerTerms;
      this.editCustomerTermsDialog = true;
    },
    submitEditCustomerTerms() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/edit",
        {
          orderId: this.$route.params.id,
          customerTerms: this.tempCustomerTerms,
          note:
            "متن بالای استعلام ویرایش شد. <hr />متن قبلی: <br/>" +
            this.orderInfo.customerTerms +
            "<hr/>متن جدید:<br/>" +
            this.tempCustomerTerms,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.editCustomerTermsDialog = false;
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitEditOrderSendReceiveMethod() {
      Axios.post(
        this.baseUrl + "/ppkpms/office/order/editOrderSendReceiveMethod",
        {
          orderId: this.$route.params.id,
          orderSendMethod: this.tempSendTerms,
          orderReceivedMethod: this.tempReceiveTerms,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.editDeliveryDialog = false;
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.editDeliveryDialog = false;
        });
    },
    editTerms() {
      this.tempTerms = this.orderInfo.terms;
      this.editTermsDialog = true;
    },
    editRequest() {
      (this.selectedDelivery = "request"),
        (this.tempReceiveTerms = this.orderInfo.orderReceivedMethod);
      this.editDeliveryDialog = true;
    },
    editOrder() {
      (this.selectedDelivery = "order"),
        (this.tempSendTerms = this.orderInfo.orderSendMethod);
      this.editDeliveryDialog = true;
    },
    clickOnAgent() {
      Axios.post(
        this.baseUrl + "/ppkpms/agent/getInfo",
        {
          contactId: this.orderInfo.contactId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.agent = res.data;
            this.agentDialog = true;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitEditTerms() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/edit",
        {
          orderId: this.$route.params.id,
          terms: this.tempTerms,
          note:
            "متن پایین استعلام ویرایش شد. <hr />متن قبلی: <br/>" +
            this.orderInfo.terms +
            "<hr/>متن جدید:<br/>" +
            this.tempTerms,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.editTermsDialog = false;
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    editRequestId() {
      this.tempRequestId = this.orderInfo.originalRequestId;
      this.editRequestIdDialog = true;
    },
    editRequestAgent() {
      this.tempRequestAgent = null;
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByCustomer",
        { customerId: this.orderInfo.customerId },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.agents = res.data.map((x) => {
              return {
                value: x.id,
                text: x.name,
              };
            });
            this.tempRequestId = this.orderInfo.originalRequestId;
            this.editRequestAgentDialog = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitEditRequestAgent() {
      // alert(this.tempRequestAgent)
      Axios.post(
        this.baseUrl + "/ppkpms/order/editContact",
        {
          orderId: this.$route.params.id,
          contactId: this.tempRequestAgent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.editRequestAgentDialog = false;
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitEditRequestId() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/edit",
        {
          orderId: this.$route.params.id,
          originalRequestId: this.tempRequestId,
          note:
            "شماره درخواست مشتری ویرایش شد. <hr />شماره قبلی: <br/>" +
            this.orderInfo.originalRequestId +
            "<hr/>شماره جدید:<br/>" +
            this.tempRequestId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.editRequestIdDialog = false;
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    removeAssignee() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/removeAssignee",
        { orderId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.getTaskInfo();
            this.removeAssigneeDialog = false;
            const title = (
              <div>
                <h5>حذف مجری</h5>
                <span>.مجری با موفقیت حذف شد</span>
              </div>
            );
            this.toast(title, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getTaskInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.vLoading = false;
            this.orderInfo = res.data;
            this.letters = this.orderInfo.letters;
            try {
              this.orderInfo.statusLink =
                "/" +
                this.role +
                "/ordersPerStatus/" +
                this.allStatuses.filter(
                  (x) => x.name == this.orderInfo.status
                )[0].id;
            } catch (error) {
              this.orderInfo.statusLink = "#";
            }
            this.vat = this.orderInfo.vat || 9;
            this.packagingCost = this.orderInfo.packagingCost || 0;
            this.transportCost = this.orderInfo.transportCost || 0;
            this.personCost = this.orderInfo.personCost || 0;
            this.coatingCost = this.orderInfo.coatingCost || 0;
            this.otherCost = this.orderInfo.otherCost || 0;
            this.certificationCost = this.orderInfo.certificationCost || 0;
            this.discount = this.orderInfo.discount || 0;
            this.hasCustomerIndex = this.orderInfo.hasCustomerIndex;
            this.hasSizeStandard = this.orderInfo.orderHasSizeStandard;
            this.orderType = this.orderInfo.orderType;

            this.orderInfo.orderItems
              ? (this.orderInfo.orderItems = JSON.parse(
                  this.orderInfo.orderItems
                ))
              : (this.orderInfo.orderItems = []);

            this.orderInfo.tempOrderItems
              ? (this.orderInfo.tempOrderItems = JSON.parse(
                  this.orderInfo.tempOrderItems
                ))
              : (this.orderInfo.orderItems = []);

            try {
              this.extraDetails = Boolean(
                this.orderInfo.orderItems
                  .map((x) => x.details)
                  .reduce((a, b) => a + b)
              );
            } catch (error) {
              this.extraDetails = false;
            }

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////
            this.myOriginalFields = this.hasCustomerIndex
              ? this.orderInfo.productsTemplate == "pk1"
                ? this.fields1CI
                : this.orderInfo.productsTemplate == "pk2"
                ? this.fields2CI
                : this.formTemplate == "pken2"
                ? this.fieldsen2CI
                : this.fieldsenCI
              : this.orderInfo.productsTemplate == "pk1"
              ? this.fields1
              : this.orderInfo.productsTemplate == "pk2"
              ? this.fields2
              : this.formTemplate == "pken2"
              ? this.fieldsen2
              : this.fieldsen;

            this.myFields = this.hasCustomerIndex
              ? this.fields1CI
              : this.fields1;

            if (!this.extraDetails) {
              this.myFields = this.myFields.filter((x) => x.key != "details");
              this.myOriginalFields = this.myOriginalFields.filter(
                (x) => x.key != "details"
              );
            }

            if (!this.hasSizeStandard) {
              this.myOriginalFields = this.myOriginalFields.filter(
                (x) => x.key != "dimensionStandard"
              );
            }

            if (this.orderType == "technical") {
              this.myOriginalFields = this.myOriginalFields.filter(
                (x) => x.key != "perPrice"
              );
              this.myOriginalFields = this.myOriginalFields.filter(
                (x) => x.key != "totalPrice"
              );
            }

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            try {
              this.myFiles = JSON.parse(this.orderInfo.files);
            } catch (error) {
              this.myFiles = [];
            }

            this.orderInfo.history ? 1 : (this.orderInfo.history = []);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    toCustomerModal() {
      this.toCustomerDialog = true;
    },
    closeCustomerMssg() {
      this.contentCustomerModal = "";
      this.subject = "";
      this.selected = "";
      this.toCustomerDialog = false;
    },
    ceoReferModal() {
      this.ceoReferDialog = true;
    },
    closeCeoRefer() {
      this.contentAssigneeModal = "";
      this.ceoReferDialog = false;
    },
    newNoteModal() {
      this.newNoteDialog = true;
      this.contentNoteModal = "";
    },
    sendNote() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/addNote",
        {
          orderId: this.$route.params.id,
          note: this.contentNoteModal,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("یادداشت به استعلام اضافه گردید", "success");
            this.contentNoteModal = "";
            this.newNoteDialog = false;
            this.getTaskInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    progressModal() {
      this.progressDialog = true;
      this.statusNoteModal = "";
      this.newStatusId = this.orderInfo.status;
    },
    submitModalProgress() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/changeStatus",
        {
          orderId: this.$route.params.id,
          newStatus: this.newStatusId,
          orderType: this.orderType,
          note: this.statusNoteModal,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("وضعیت استعلام تغییر داده شد", "success");
            this.progressDialog = false;
            this.statusNoteModal = "";
            this.getTaskInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    revisionModal() {
      this.revisionDialog = true;
      this.revisionNoteModal = "";
      this.sourceRevisionId = this.orderInfo.revision;
      this.revisionOptions = [];
      if (this.sourceRevisionId > 0) {
        for (
          let revisions = 0;
          revisions <= this.sourceRevisionId;
          revisions++
        ) {
          this.revisionOptions.push({
            text: "کپی از نسخه " + revisions,
            value: revisions,
          });
        }
        this.revisionNoteModal = "";
      }
    },

    submitRevisionModal() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/revision",
        {
          orderId: this.$route.params.id,
          revision: this.sourceRevisionId,
          note: this.revisionNoteModal,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("ریویژن با موفقیت ثبت شد", "success");
            this.revisionDialog = false;
            this.revisionNoteModal = "";
            this.getTaskInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    progressTimePercent() {
      this.Today = new Date();

      this.timeProgress = Math.floor(
        ((this.Today - this.startDate) / (this.dueDate - this.startDate)) * 100
      );
      if (this.timeProgress <= 0) {
        this.timeProgress = 0;
      } else if (this.timeProgress >= 100) {
        this.timeProgress = 100;
      }
      this.shamsiStartDate = moment(this.startDate).format("jYYYY/jMM/jDD");
      this.shamsiDueDate = moment(this.dueDate).format("jYYYY/jMM/jDD");
    },
    gotoPricing() {
      this.$router.push(
        "/" +
          localStorage.role +
          "/query/" +
          this.orderInfo.customerId +
          "/" +
          this.$route.params.id
      );
    },
    openModalGet(order) {
      this.getCustomerDialog = true;
      // this.getContent = "";
      // this.file = [];
      // this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalGet() {
      this.getCustomerDialog = false;
    },
    submitCustomerResponse() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/customerResponse",
        {
          orderId: this.$route.params.id,
          targetFile: JSON.stringify(this.uploadedFiles),
          customerResponse: this.response,
          note: this.getContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("نظر مشتری به ثبت رسید", "success");
            this.getCustomerDialog = false;
            this.getTaskInfo();
            this.getContent = "";
            this.file = [];
            this.uploadedFiles = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    delFile(item) {
      this.selectedFile = item;
      this.sureDelFile = true;
    },
    doDelFile() {
      this.vLoading = true;
      this.sureDelFile = false;
      Axios.post(
        this.baseUrl + "/ppkpms/order/removeFile",
        {
          orderId: this.$route.params.id,
          fileName: this.selectedFile.name,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("فایل با موفقیت از پرونده حذف گردید", "success");
            this.getTaskInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    upload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            // this.uploadedFiles=d.data[0];
            Axios.post(
              this.baseUrl + "/ppkpms/order/attachFile",
              {
                orderId: this.$route.params.id,
                file: JSON.stringify(d.data[0]),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("token"),
                },
              }
            )
              .then((res) => {
                if (res.status == 200) {
                  this.getTaskInfo();
                } else {
                  const title = (
                    <div>
                      <h5>خطا </h5>
                      <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                    </div>
                  );
                  this.toast(title, "error");
                }
              })
              .catch((err) => {
                this.toast(err.response.data, "error");
              });
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    upload2(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data[0];
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.currentUserId = localStorage.getItem("userId");
    this.getTaskInfo();
  },
};
</script>
<style>
* {
  font-family: iransans;
}

@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
</style>
<style scoped>
.display {
  display: inline-block;
}

hr {
  border: none;
  border-top: 3px double #333;
  color: #333;
  overflow: visible;
  text-align: center;
  height: 5px;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}

blink {
  animation: 1s linear infinite condemned_blink_effect;
}

@keyframes condemned_blink_effect {
  0% {
    visibility: hidden;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}
</style>
